import { Link } from 'react-router-dom'
import { Code2 } from 'lucide-react'
import Seo from '../components/Seo.jsx'
import Container from '../components/Container.jsx'
import PageHeader from '../components/PageHeader.jsx'
import ProductCard from '../components/ProductCard.jsx'
import CTA from '../components/CTA.jsx'
import { products } from '../data/products.js'

export default function Products() {
  return (
    <>
      <Seo
        title="Products"
        description="Spectranox SaaS products on subscription, SOC security monitoring, secure business mail, an LMS and a headless CMS. Hosted and managed by us."
        path="/products"
      />
      <main className="pt-20">
        <PageHeader
          eyebrow="Our products"
          title="Software you can subscribe to today"
          subtitle="Tools we build, host and maintain, launch fast on a predictable subscription, with no infrastructure to manage."
        />

        <section className="py-16">
          <Container>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {products.map((p) => (
                <ProductCard key={p.slug} product={p} />
              ))}
            </div>

            {/* Custom build prompt */}
            <div className="mt-12 flex flex-col items-center justify-between gap-6 rounded-2xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm sm:flex-row sm:text-left">
              <div className="flex items-start gap-4">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand-400/10 text-brand-300 ring-1 ring-brand-400/20">
                  <Code2 className="h-6 w-6" />
                </span>
                <div>
                  <h3 className="text-lg">Need something custom?</h3>
                  <p className="mt-1 max-w-xl text-sm text-slate-400">
                    We also design and build bespoke software, then host it for you on subscription. If our products
                    don’t fit exactly, we’ll build what does.
                  </p>
                </div>
              </div>
              <Link to="/contact" className="btn-primary shrink-0">Talk to us</Link>
            </div>
          </Container>
        </section>

        <CTA
          title="Not sure which plan fits?"
          subtitle="Tell us about your team and we’ll recommend the right product and plan, or build a custom solution."
          primaryLabel="Get in touch"
          secondaryLabel="Browse services"
          secondaryTo="/services"
        />
      </main>
    </>
  )
}
